import type { SuitabilityTestDefinition } from 'src/suitability/engine/types';
import type { LiftAnswers } from './answers';
import { isBlock1Complete, isBlock2Complete, isBlock3Complete } from './gating';
import { StepBlock1 } from './step-block1';
import { StepBlock2 } from './step-block2';
import { StepBlock3 } from './step-block3';
import { StepSustainability } from './step-sustainability';
import { isSustainabilityComplete } from './sustainability';

/**
 * Ninguna respuesta arranca con estado: las 25 son de opción única y empiezan sin
 * responder, y el bloque de sostenibilidad es opcional, así que también arranca vacío
 * (sembrarlo con `{}` lo daría por empezado). En Wio hacía falta sembrar el mapa de
 * toggles de P5.
 */
const INITIAL_ANSWERS: LiftAnswers = {};

/**
 * Test de idoneidad MiFID II de Lift, versión 1.
 *
 * Cada paso declara su `stepKey` del catálogo, no su etiqueta: el texto lo pone el
 * catálogo del API y así vive en un solo sitio, en el idioma en que se pidió.
 *
 * El bloque de sostenibilidad va el ÚLTIMO y es opcional: su puerta deja pasar con el
 * bloque en blanco, y sólo exige el árbol entero si el cliente ha entrado en él.
 */
export const liftV1: SuitabilityTestDefinition<LiftAnswers> = {
  company: 'lift',
  version: 'v1',
  initialAnswers: INITIAL_ANSWERS,
  steps: [
    {
      stepKey: 'block1',
      Component: StepBlock1,
      isComplete: isBlock1Complete,
    },
    {
      stepKey: 'block2',
      Component: StepBlock2,
      isComplete: isBlock2Complete,
    },
    {
      stepKey: 'block3',
      Component: StepBlock3,
      isComplete: isBlock3Complete,
    },
    {
      stepKey: 'sustainability',
      Component: StepSustainability,
      isComplete: isSustainabilityComplete,
    },
  ],
};
